import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BlogHero() {
  return <section className="bg-black pt-[180px] pb-[80px] lg:pt-[200px] lg:pb-[120px] relative overflow-hidden" data-id="element-358">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10" data-id="element-359">
        <AnimateOnScroll className="flex flex-col items-center text-center" data-id="element-360">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-6 font-[Poppins,_sans-serif]" data-id="element-361">
            BLOG
          </span>

          <h1 className="text-[32px] sm:text-5xl md:text-6xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-362">
            THE BE CLINICAL BLOG
          </h1>

          <p className="font-serif italic text-[17px] lg:text-[22px] text-white/85 leading-[1.6] mb-8 max-w-[650px] mx-auto" data-id="element-363">
            Expert insights on aesthetics, wellness, and looking your best at
            any age
          </p>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto" data-id="element-364"></div>
        </AnimateOnScroll>
      </div>
    </section>;
}